import { useMemo } from 'react';
import { useElementProps } from '../../core/elements';
import { Layout } from '../../primitives/container/layout';
import Plot from '../../primitives/container/Plot';
import Group from '../../primitives/shape/Group';
import { useSafeAccessors } from '../../primitives/shape/utils/accessors';
import { DEFAULT_MARGIN } from '../common/constants/constants';
import { DataTable as DonutDataTable } from './elements/data-table';
import { DonutLegend } from './elements/legend';
import { DonutPatterns } from './elements/patterns';
import { DonutStackSlot } from './elements/stack';
import { DonutTooltip } from './elements/tooltip';
import { DonutDataProvider } from './providers/data';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function useAccessors(_ref) {
  let {
    valueAccessor,
    labelAccessor,
    colorAccessor
  } = _ref;
  const [value, label, color] = useMemo(() => {
    const [v] = useSafeAccessors(valueAccessor);
    const [l] = useSafeAccessors(labelAccessor);
    const [c] = useSafeAccessors(colorAccessor);
    return [v, l, c];
  }, [valueAccessor, labelAccessor, colorAccessor]);
  return {
    value,
    label,
    color
  };
}

/*
Pure Donut chart component
*/
export function PureDonutChart(_ref2) {
  let {
    data,
    width,
    height,
    innerRadius: userInnerRadius,
    outerRadius: userOuterRadius,
    margin = DEFAULT_MARGIN,
    valueAccessor,
    colorAccessor,
    labelAccessor,
    svgRef
  } = _ref2;
  const layoutProps = useElementProps(Layout);
  const {
    value,
    label,
    color
  } = useAccessors({
    valueAccessor,
    labelAccessor,
    colorAccessor
  });

  // TODO: FIX THIS SO WE KNOW WHEN TO SHIFT PIE CHART OVER.
  // const layoutProps = useElementProps(Layout);
  // const sideBySide = !layoutProps.gridTemplate?.includes('legend');

  const plotHeight = Math.max(0, height - (margin.top + margin.bottom));
  const plotWidth = Math.max(0, width - (margin.left + margin.right));
  const outerRadius = userOuterRadius || Math.min(plotHeight || 0, plotWidth || 0) / 2;
  const innerRadius = userInnerRadius !== undefined ? userInnerRadius : outerRadius / 1.3;

  /* When height is not provided, the chart's height will be set to match its width */
  const calculateHeight = layoutProps.height == null && layoutProps.width != null;
  const fixedHeight = calculateHeight ? `${plotWidth}px` : '100%';
  return /*#__PURE__*/_jsxs(DonutDataProvider, {
    data: data,
    width: plotWidth,
    height: plotHeight,
    valueAccessor: value,
    labelAccessor: label,
    colorAccessor: color,
    margin: margin,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    children: [/*#__PURE__*/_jsx(DonutLegend, {}), /*#__PURE__*/_jsx(Plot, {
      innerRef: svgRef,
      height: fixedHeight,
      children: /*#__PURE__*/_jsxs(Group, {
        children: [/*#__PURE__*/_jsx(DonutPatterns, {}), /*#__PURE__*/_jsx(DonutStackSlot, {})]
      })
    }), /*#__PURE__*/_jsx(DonutDataTable, {}), /*#__PURE__*/_jsx(DonutTooltip, {})]
  });
}